export default "__VITE_ASSET__7GqJP4RD__"